import { AlertDescription, Alert as ShadAlert } from '@neo/primitives/base/alert'
import { Button } from '@neo/primitives/button'
import { Info } from 'lucide-react'
import { useState } from 'react'
import { DuplicateFlowDialog } from 'v2/pages/settings/flows/duplicate-flow-dialog'
import type { FlowData } from '../../types'
import { legacyDuplicateFlowId } from './legacy-duplicate'

interface LegacyReadOnlyBannerProps {
  flowData: FlowData
}

/**
 * Legacy agents are read-only — the only way to make changes is to duplicate
 * them into a new, editable agent. Surface that clearly between the title bar
 * and the tabs, with the duplicate action inline so it's one click away.
 */
export const LegacyReadOnlyBanner = ({ flowData }: LegacyReadOnlyBannerProps) => {
  // Holds the flow id while the duplicate dialog is open ('' = closed).
  const [duplicateFlowId, setDuplicateFlowId] = useState('')
  const sourceId = legacyDuplicateFlowId(flowData.phlo)

  return (
    <div className="px-4 pb-2">
      <ShadAlert variant="info" className="items-center py-2">
        <Info size={16} />
        <AlertDescription className="flex flex-1 items-center justify-between gap-3 text-xs-400">
          <span>
            {sourceId
              ? 'This is a read-only legacy agent. Duplicate it to make changes.'
              : 'This is a read-only legacy agent.'}
          </span>
          {sourceId && (
            <Button
              size="sm"
              variant="outline"
              onClick={() => setDuplicateFlowId(sourceId)}
              data-testid="button-duplicate-legacy-agent"
            >
              Duplicate to edit
            </Button>
          )}
        </AlertDescription>
      </ShadAlert>
      {duplicateFlowId && (
        <DuplicateFlowDialog
          state={duplicateFlowId}
          setState={setDuplicateFlowId}
          name={flowData.phlo.name}
        />
      )}
    </div>
  )
}
